import setCalendarPublishingOperation from 'owa-service/lib/operation/setCalendarPublishingOperation';
import SetCalendarPublishingRequest from 'owa-service/lib/factory/setCalendarPublishingRequest';
import SetCalendarPublishingResponse from 'owa-service/lib/contract/SetCalendarPublishingResponse';
import folderIdFactory from 'owa-service/lib/factory/folderId';

export default function createPublishingPermissionService(
    folderId: string,
    detailLevel: string,
    publishCalendar: boolean = true,
    resetUrl: boolean = false
): Promise<SetCalendarPublishingResponse> {
    let publish = detailLevel != 'Disabled' && publishCalendar;

    return setCalendarPublishingOperation({
        request: SetCalendarPublishingRequest({
            CalendarId: folderIdFactory({ Id: folderId }),
            Publish: publish,
            ResetUrl: resetUrl,
            DetailLevel: detailLevel,
        }),
    })
        .then(response => {
            if (response && response.WasSuccessful) {
                return response;
            } else {
                return null;
            }
        })
        .catch(error => {
            return Promise.resolve(null);
        });
}
